export class ApiError extends Error {
  status: number;

  constructor(status: number, detail: string) {
    super(detail);
    this.status = status;
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...init,
    headers: { "Content-Type": "application/json", ...init?.headers },
  });
  if (!res.ok) {
    let detail = res.statusText;
    try {
      const body = await res.json();
      if (typeof body.detail === "string") detail = body.detail;
    } catch {
      // 본문이 JSON이 아니면 statusText 유지
    }
    throw new ApiError(res.status, detail);
  }
  if (res.status === 204) return undefined as T;
  return res.json();
}

export interface User {
  id: number;
  username: string;
  display_name: string;
  role: "operator" | "node_manager" | "admin";
  member_id: number | null;
  is_active: boolean;
}

export const ROLE_LABELS: Record<User["role"], string> = {
  operator: "담당자",
  node_manager: "노드 담당자",
  admin: "관리자",
};
